import React from 'react';
import { styled } from '@mui/material';

import { Container, Panel } from 'shell/components';

const Desktop = ({ options, selected, onBeforeChange, onChange }) => {
    return (
        <CustomContainer device={'desktop'}>
            <CustomPanel
                label={'Profile & Settings'}
                options={options}
                selected={selected}
                onBeforeChange={onBeforeChange}
                onChange={onChange}
            />
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(() => {
    return {
        display: 'block',
        height: 'unset',
    };
});

const CustomPanel = styled(Panel)(() => {
    return {
        minHeight: '100%',
        height: 'auto',
    };
});

export default Desktop;
